import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import { useColors } from '../theme/ColorModeContext';

interface StatusBadgeProps {
  solved: boolean;
  size?: 'small' | 'medium';
}

const StatusBadge = ({ solved, size = 'small' }: StatusBadgeProps) => {
  const colors = useColors();
  if (solved) {
    return (
      <CheckCircleIcon
        fontSize={size}
        sx={{
          color: colors.accent.green,
          filter: `drop-shadow(0 0 4px ${colors.accent.greenGlow})`,
        }}
      />
    );
  }
  return (
    <RadioButtonUncheckedIcon
      fontSize={size}
      sx={{ color: colors.text.muted }}
    />
  );
};

export default StatusBadge;
